import { cutToast } from 'utility/toast';
import { useMutation } from '@apollo/client';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { EntityAction, EntityType } from 'common/types/utility';
import React from 'react';

import { NotificationCycleRowItem } from '..';

import NOTIFY_CYCLE_DELETE from './NotifyTimeDelete.graphql';
import {
  NotifyTimeDelete,
  NotifyTimeDeleteVariables,
} from './__generated__/NotifyTimeDelete';

interface DeleteNotifyCycleProps {
  selectedRows: NotificationCycleRowItem[];
}

export const DeleteNotifyCycle: React.FC<DeleteNotifyCycleProps> = ({
  selectedRows,
}) => {
  const [deleteNotifyCycle] = useMutation<
    NotifyTimeDelete,
    NotifyTimeDeleteVariables
  >(NOTIFY_CYCLE_DELETE, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const deletableRows: NotificationCycleRowItem[] = selectedRows.filter(
      (item) => item._isDeletable
    );
    const entityDelete: EntityDeleteInput[] = deletableRows.map((item) => {
      return { id: item.id, rowTimestamp: item._rowTimestamp! };
    });
    const { errors } = await deleteNotifyCycle({
      variables: {
        input: {
          entityDelete,
        },
      },
      update(cache, { data }) {
        if (!!data?.notifyTimeDelete?.deletedEntities?.length)
          deletableRows.forEach((item) => {
            const identity = cache.identify({
              ...item,
            });
            cache.evict({ id: identity });
            cache.gc();
          });
      },
    });
    if (errors?.length) cutToast.error(errors[0].message);
    else {
      cutToast.success('Notify cycle deleted successfully.');
    }
  };

  return (
    <ActionMessageModal
      entityType={EntityType.NotifyCycle}
      action={EntityAction.Remove}
      disabled={!selectedRows.some((selected) => selected._isDeletable)}
      visible={!!selectedRows.length}
      multiple={{
        validCount: selectedRows.filter((selected) => selected._isDeletable)
          .length,
        invalidNames: selectedRows
          .filter((selected) => !selected._isDeletable)
          .map((selected) => selected.notifyType?.description || ''),
      }}
      onConfirm={_onConfirm}
    />
  );
};
